export default "__VITE_PUBLIC_ASSET__4a0615d1__"